export default __webpack_public_path__ + "static/media/carvana-family.0d8b910c.svg";